import $ from 'jquery';

function CatalogCtrl() {
	this.init();
}

CatalogCtrl.prototype.init = function() {
	$('.btn-catalog-info').on('click', this.clickInfo);
	this.imageGallery();
}

CatalogCtrl.prototype.clickInfo = function() {
	const self = $(this);
	const $self_next = self.next();
	if ($self_next.hasClass('hover')) {
		$self_next.removeClass('hover');
	} else {
		$('.catalog-container').find('.btn-catalog-info').next().removeClass('hover');
		$self_next.addClass('hover');
	}
}

CatalogCtrl.prototype.imageGallery = function(e) {
	const $thumbnail = $('.catalog-picture-list-item');
	$thumbnail.on('click', function(e) {
		e.preventDefault();
		$thumbnail.removeClass('active');
		$(this).addClass('active');

		var dataCatalogTarget = $(this).data('catalog-target');
		var $catalog_body = $('[data-catalog-body="' + dataCatalogTarget + '"]');
		$('.catalog-picture-body').find('.pic').removeClass('active');
		$catalog_body.addClass('active');
	});
}

new CatalogCtrl();